import { z } from 'zod';

import { zodCallOffResponseSchema } from '../validations';

// Request payload schema for requesting changes
export const zodRequestChangesPayloadSchema = z.object({
  changeNotes: z.string().nullish(),
});

// Response schema (re-export from shared)
export { zodCallOffResponseSchema as zodRequestChangesResponseSchema };
